import { render, staticRenderFns } from "./UploadDocumentL.vue?vue&type=template&id=6f49e152&scoped=true"
import script from "./UploadDocumentL.vue?vue&type=script&lang=js"
export * from "./UploadDocumentL.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentL.vue?vue&type=style&index=0&id=6f49e152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49e152",
  null
  
)

export default component.exports